import React from 'react';
import { PageProps } from 'gatsby';
import DebugPill from './debug-pill';
import { useDebug } from './debug-provider';
import { MicrositeContext } from '../../../contexts/franchise/microsite-context';

interface FranchiseNumberDebugProps {
    pageProps?: Omit<PageProps, 'children'>;
}

const FranchiseNumberDebug = ({ pageProps }: FranchiseNumberDebugProps): JSX.Element | null => {
    const { showFranchiseNumber } = useDebug();
    const micrositeContext = React.useContext(MicrositeContext);

    if (!showFranchiseNumber) {
        return null;
    }

    // Try to get franchise number from context first
    let franchiseNumber: number | undefined;
    let isMicrosite = false;

    if (micrositeContext) {
        isMicrosite = micrositeContext.isMicrosite;
        franchiseNumber = micrositeContext.franchise?.franchiseNumber;
    } else if (pageProps && 'pageContext' in pageProps) {
        // Fallback to pageContext if context is not available
        const context = pageProps.pageContext as { franchiseNumber?: number };
        if (context?.franchiseNumber) {
            franchiseNumber = context.franchiseNumber;
            // Assume it's a microsite if franchiseNumber is in pageContext
            isMicrosite = true;
        }
    }

    if (isMicrosite && franchiseNumber) {
        return (
            <DebugPill>
                {`Franchise Number: ${franchiseNumber}`}
            </DebugPill>
        );
    }

    return null;
};

export default FranchiseNumberDebug;
